import * as auth from './auth';

export class API {
    validating: null | Promise<any>;
    client: null | Bee.AWSClient;
    isSetup: boolean;
    constructor() {
        this.validating = null;
        this.client = null;
        this.isSetup = false;
    }

    setup = async () => {
        this.configureAWS();

        this.validating = auth.credentialsAreValid();

        const isValid = await this.validating;

        this.validating = null;

        this.isSetup = true;

        if (isValid) {
            return true;
        } else {
            console.error('Failed authentication');
            return false;
        }
    }

    configureAWS = () => {
		const win = window as Bee.WindowExtended;
		const AWS = win.AWS;
		AWS.config.region = 'us-east-2';

		const params = auth.getAuthParams();

		AWS.config.credentials = new (AWS.CognitoIdentityCredentials as any)({
			IdentityPoolId: 'us-east-2:5eac8ede-8bea-444e-8a03-daf0e9cc79c9',
			Logins: {
				'cognito-idp.us-east-2.amazonaws.com/us-east-2_aEjtQAeYj': params.id_token
			}
		});
    }
    
    getClient = () => {
        if (!this.client) {
            this.client = auth.getClient();
        }
        return this.client;
    }
    
    makeApiCall = async (
        method: string,
        params: Bee.Params = {},
        body: Bee.Body = {},
        extraParams: Bee.ExtraParams = {}
    ): Promise<Bee.ClientResponse> => {
        console.log(method);

        if (!this.isSetup) {
            await this.setup();
        }

        if (this.validating) {
            try {
                await this.validating;
            } catch (e) {
                console.error(e);
            }
        }

        const client = this.getClient();

        try {
            const rep: Bee.ClientResponse = await client[method].call(null, params, body, extraParams);
            console.log(rep);
            return rep;
        } catch (e) {
            console.error(e);
            return e as Bee.ClientResponse;
        }
    };
    
    public getQuizzes = async (params: Bee.Params): Promise<Bee.ClientResponse> => {
        try {
            const rep: Bee.ClientResponse = await this.makeApiCall('apiQuizGet', params);
            return rep;
        } catch(e) {
            console.error(e);
            return e;
        }
    }

    public getQuiz = async (id: string): Promise<Bee.ClientResponse> => {
        try {
            const authParams = auth.getAuthParams();
            const rep: Bee.ClientResponse = await this.makeApiCall(
                'apiQuizIdGet',
                { access_token: authParams.access_token, id },
                { access_token: authParams.access_token },
                {},
            );

            return rep;
        } catch(e) {
            console.error(e);
            return e;
        }
    }

    public getNext = async (): Promise<Bee.ClientResponse> => {
        try {
            const rep: Bee.ClientResponse = await this.makeApiCall('apiQuizNextGet');
            return rep;
        } catch(e) {
            console.error(e);
            return e;
        }
    }
    
    public getLeaderboard = async (params: Bee.Params): Promise<Bee.ClientResponse> => {
        try {
            const rep: Bee.ClientResponse = await this.makeApiCall('apiLeaderboardGet', params);
            return rep;
        } catch(e) {
            console.error(e);
            return e;
        }
    }

    public getParticipate = async (params: Bee.Params): Promise<Bee.ClientResponse> =>  {
        const authParams = auth.getAuthParams();
        const rep: Bee.ClientResponse = await this.makeApiCall(
            'apiParticipateGet',
            { access_token: authParams.access_token, ...params },
            { access_token: authParams.access_token },
            {},
        );
        return rep;
    }
    
    public postQuiz = async (body: any): Promise<Bee.ClientResponse> => {
        const authParams = auth.getAuthParams();
        const rep: Bee.ClientResponse = await this.makeApiCall(
            'apiParticipatePost',
            { access_token: authParams.access_token },
            { access_token: authParams.access_token, ...body },
            {},
        );
        return rep;
    }
    
    public postCreateQuiz = async (body: any): Promise<Bee.ClientResponse> => {
        const authParams = auth.getAuthParams();
        const rep: Bee.ClientResponse = await this.makeApiCall(
            'apiQuizPost',
            { access_token: authParams.access_token },
            { access_token: authParams.access_token, ...body },
            {},
        );
        return rep;
    }

    public postUpdateQuiz = async (id: string, body: any): Promise<Bee.ClientResponse> => {
        const authParams = auth.getAuthParams();
        const rep: Bee.ClientResponse = await this.makeApiCall(
            'apiQuizIdPost',
            { access_token: authParams.access_token, id },
            { access_token: authParams.access_token, ...body },
            {},
        );
        return rep;
    }
    
    public postPublishQuiz = async (id: string): Promise<Bee.ClientResponse> => {
        const authParams = auth.getAuthParams();
        const rep: Bee.ClientResponse = await this.makeApiCall(
            'apiQuizIdPublishPost',
            { access_token: authParams.access_token, id },
            { access_token: authParams.access_token },
            {},
        );
        return rep;
    }
    
    public postUnpublishQuiz = async (id: string): Promise<Bee.ClientResponse> => {
        const authParams = auth.getAuthParams();
        const rep: Bee.ClientResponse = await this.makeApiCall(
            'apiQuizIdPublishDelete',
            { access_token: authParams.access_token, id },
            { access_token: authParams.access_token },
            {},
        );
        return rep;
    }
    
    public postDeleteQuiz = async (id: string): Promise<Bee.ClientResponse> => {
        const authParams = auth.getAuthParams();
        const rep: Bee.ClientResponse = await this.makeApiCall(
            'apiQuizIdDelete',
            { access_token: authParams.access_token, id },
            { access_token: authParams.access_token },
            {},
        );
        return rep;
    }
}



// WEBPACK FOOTER //
// ./src/api/actions.ts